import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const FilterForm = styled(Form)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    display: flex;
    flex-direction: column;
  }
`;

export const Label = styled.label`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.black};
  opacity: 0.65;
  padding: 0 0 0.6rem 1.2rem;
  user-select: none;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;

  input {
    padding: 1rem 0 !important;
    background-color: transparent;
  }
`;
